import { useCallback, useEffect, useState } from 'react';
import { routes } from '~/constants';
import { useOverlayContext } from '~/contexts';
import { useBiometricMethodLabel } from '~/hooks/useBiometricMethodLabel';
import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
export const useBiometricLogin = (errorToastTestId)=>{
    const { native, cookies, browser: { changeLocation, scrubUrlFragment } } = useIoContext();
    const { showErrorToast } = useOverlayContext();
    const { t: loginTexts } = useLocaleKeys('pages.auth.login');
    const method = useBiometricMethodLabel();
    const enabled = native.isNative;
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const signIn = useCallback(async ()=>{
        setLoading(true);
        const outcome = await native.biometric.signIn((token)=>cookies.setAuthTokenForNative(token, {
                skipBiometricMarkerClear: true
            }));
        if (outcome.status === 'reset') {
            setVisible(false);
            showErrorToast(loginTexts.biometricResetToast({
                method
            }), errorToastTestId);
        }
        if (outcome.status !== 'signedIn') {
            setLoading(false);
            return;
        }
        scrubUrlFragment();
        changeLocation(routes.home);
    }, [
        errorToastTestId,
        method
    ]);
    useEffect(()=>{
        if (!enabled) {
            return undefined;
        }
        let cancelled = false;
        let unsubscribe;
        const refreshVisibility = async ()=>{
            const status = await native.biometric.getStatus();
            if (!cancelled) {
                setVisible(status.offerLogin);
            }
        };
        const init = async ()=>{
            await refreshVisibility();
            if (cancelled) {
                return;
            }
            unsubscribe = await native.biometric.onStatusChange(()=>void refreshVisibility());
            const claimed = await native.biometric.claimAutoLogin();
            if (claimed && !cancelled) {
                void signIn();
            }
        };
        void init();
        return ()=>{
            cancelled = true;
            unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
        };
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
    }, [
        enabled
    ]);
    return {
        visible,
        loading,
        method,
        signIn
    };
};
